import { TUpdateCurrentUserPersonalDataParams } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';

export const updateCurrentUserPersonalData = async (
  params: TUpdateCurrentUserPersonalDataParams
) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
